module.exports = __webpack_public_path__ + "81addc4c9107672fcd60931ed9b2fb9b.svg";